import { render, staticRenderFns } from "./MemberViewUserInfoCard.vue?vue&type=template&id=47288811&"
import script from "./MemberViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./MemberViewUserInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./MemberViewUserInfoCard.vue?vue&type=style&index=0&id=47288811&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports